module.exports = __webpack_public_path__ + "img/slideVerify_01.b39924b4.png";